import { directiveSettings } from '../../utils/parse';
import { onResize, onScroll, getScrollTop } from '../../utils/window';
import { frame } from '../../utils/drawing';
/**
 * @module directives/scroll/parallax
 */

/**
 * Adds parallax to an element.
 * Parallax with 75% speed: <div data-sw-parallax="0.75"></div>
 * Parallax for background images: <div data-sw-parallax="{ scale: true }"></div>
 */
export default function parallaxDirective() {
  document.querySelectorAll('[data-sw-parallax]').forEach(element => {
    const data = element.getAttribute('data-sw-parallax'),
    settings = directiveSettings(data, {
      speed: 0.5,
      align: 0.5,
      target: false,
      scale: false,
    }, 'speed'),
    target = settings.target && !settings.scale ? document.getElementById(settings.target) : null;

    let height, offsetTop, transform;
    const scroll = _ => {
      const scrollTop = getScrollTop(),
      targetHeight = (target ? target.clientHeight : window.innerHeight),
      scaleOffset = (targetHeight - height) * settings.align,
      translate = (scrollTop - offsetTop + scaleOffset) * (settings.speed - 1);
      element.style.transform = `translate3d(0, ${-translate}px, 0) ${transform}`;
    },
    setup = _ => {
      element.style.transform = '';
      element.style.transformOrigin = 'top center';
      element.offsetWidth; // accesss for reflow
      height = element.offsetHeight;
      offsetTop = element.offsetTop;
      if (settings.scale) {
        const viewHeight = Math.min(window.innerHeight, offsetTop + height),
        newHeight = viewHeight - (viewHeight - height) * settings.speed;
        transform = `scale(${newHeight / height})`;
      } else {
        transform = '';
      }
      scroll();
    };

    onResize(setup);
    onScroll(scroll);
    window.addEventListener('load', ()=>{
      frame(setup);
    });
  });
}



// WEBPACK FOOTER //
// ./source/scripts/directives/scroll/parallax.js